import auth from "@/utils/auth";

export default {
    data() {
        let userInfoValue = {};
        if (auth.isLogin()) {
          userInfoValue = auth.getAuth();
        }
        return {
            authOrization: [],
            userInfoValue
        }
    },
    methods: {
        isHavePermission(code) {
            let elements = this.$store.state.user.elements
            let isHaveName = []
            if (elements && elements.length > 0) {
                isHaveName = elements.filter(item => item.code === code)
            }
            return isHaveName.length > 0
        },
    }
}